import Axios from 'axios';

import { withJWTiam } from '@skitter/workativ-iam-client';
import { Lazy } from '@skitter/workativ-iam-client/dist/types';
import jwt_decode from 'jwt-decode';

import {
  accessTokenElector,
  addHandlerForAccessToken,
  postMessageForAccessToken,
} from '../user-sessions/across-tabs';
import { loginApiURL } from './api-utils';
import { signal, computed, useComputed, Signal } from '@preact/signals-react';
import * as R from 'ramda'
import { getProductId } from './utils';
const MOCK_AUTH_PERMISSIONS = false as boolean;

export interface TreeT<T> {
  permission: T
  children: TreeT<T>
}

type PathT = ({
  type: string;
  value: string;
  wildCard: false;
} | {
  type: string;
  wildCard: true;
})

type PermissionT = {
  [key:string]:number
}
/*eslint-disable*/
const expiredToken =
  'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MzcsImVtYWlsIjoic2hyaS5naGF5YXRocmlAc2tpdHRlci5pbiIsIndzcyI6W3siaWQiOjE3NiwibmFtZSI6Im5pcnVwIiwib3duZXJJZCI6Mzd9LHsiaWQiOjE4OSwibmFtZSI6InNraXR0ZXIiLCJvd25lcklkIjozMn1dLCJpYXQiOjE1OTcxNDg3OTksImV4cCI6MTU5NzE0OTY5OX0.qAb-y9x5NduqCKmoUiGBsnhueJbEzuS63RnW-SWX86U';

const accessToken$ = signal<string | null>(null);

export const authorizeToken = (token:string)=>{
      postMessageForAccessToken({ token: token, action: 'updated' });
      Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      sessionStorage.setItem('access_token', token);
      accessToken$.value = token;
      // console.log(accessToken$.value,token,'authorizeToken')
}

const loadToken = async (x: string = 'unk own') => {
  // console.log('loadToken called from :::', x)
  try {
    //await applyOnce()
    if (accessTokenElector.isLeader) {
      // console.log('debug - token - request time  ::::', new Date(), Date.now())
      const resp = await Axios.get(loginApiURL('/auth-tokens/access_token'), {
        withCredentials: true,
      });
      // const resp = await Promise.resolve({ data: expiredToken })
      const token = resp.data;
      // console.log(token, 'loadToken')
      // const token = 'MOCK_TOKEN'
      // console.log('debug - token ::::', token)
      // console.log('debug - token - time ::::', new Date(), Date.now())
      authorizeToken(token)
      // postMessageForAccessToken({ token: token, action: 'updated' });
      // Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
      // sessionStorage.setItem('access_token', token);
      // accessToken$.value = token;
      return token;
    } else {
      // console.log('awaitLeadership from loadToken called :::')
      return awaitLeadership();
    }
  } catch (e) {
    // console.log('error in token ::: ', e)
    // console.log('error in token ::: ', Object.entries(e))
    // console.log('stringified :::', JSON.stringify(e, null, 4))
    if (e.response && e.response.status == 401) {
      location.replace(window.location.origin + '/authentication/u');
    } else {
      Axios.defaults.headers.common['Authorization'] = `Bearer `;
    }
    return null;
  }
};

const retryCounter = (noOfTries: number) => (timeOut: number) => {
  let counter = noOfTries;

  return {
    getCount: function () {
      return counter;
    },
    resetCounter: function () {
      counter = noOfTries;
    },
    timeOut: function () {
      return new Promise(function (resolve, _) {
        setTimeout(function () {
          counter = counter - 1;
          // console.log('counter ::: resoved', counter)
          if (counter === 0) {
            resolve('MAX_RETRY_LIMIT_REACHED');
          } else {
            resolve('TIMED_OUT');
          }
        }, timeOut);
      });
    },
  };
};

const retryAndtimeOut = retryCounter(10)(500);

const awaitLeadership: Lazy<Promise<string | null>> = async () => {
  // console.log('awaitLeadership ::: called')
  return Promise.race([
    accessTokenElector.awaitLeadership(),
    retryAndtimeOut.timeOut(),
  ]).then((x) => {
    if (x === 'MAX_RETRY_LIMIT_REACHED') {
      // console.log('MAX_RETRY_LIMIT_REACHED', retryAndtimeOut.getCount())
      location.replace(window.location.origin + '/authentication/u');
      return null;
    }

    if (x === 'TIMED_OUT') {
      const item = sessionStorage.getItem('access_token');
      // console.log('TIMED_OUT', retryAndtimeOut.getCount())
      if (item === null) {
        // console.log('loadToken in awaitLeadership ::: 1')
        return loadToken('from timedout');
      }
      retryAndtimeOut.resetCounter();
      Axios.defaults.headers.common['Authorization'] = `Bearer ${item}`;
      return item;
    }
    retryAndtimeOut.resetCounter();
    // console.log('loadToken in awaitLeadership ::: 2', retryAndtimeOut.getCount())
    return loadToken('awaitLeadership end');
  });
};
export const { executeWithAuthToken } =
  MOCK_AUTH_PERMISSIONS === false
    ? withJWTiam({
        graceIntervalForInavtivation: 120,
        withLog: false,
      })(awaitLeadership)
    : { executeWithAuthToken: (x: () => Promise<any>) => x() };
// export const executeWithAuthToken = (x: () => Promise<any>) => x()

addHandlerForAccessToken(({ token }) => {
  Axios.defaults.headers.common['Authorization'] = `Bearer ${token}`;
  sessionStorage.setItem('access_token', token);
  accessToken$.value = token;
});

const parsedToken$ = computed<Record<string, any> | null>(() => {
  // if (MOCK_AUTH_PERMISSIONS) {
  //   return accessToken$.value === null
  //     ? null
  //     : {
  //         foo: 'bar',
  //         exp: 1393286893,
  //         iat: 1393268893,
  //         token: accessToken$.value,
  //       };
  // }

  return accessToken$.value === null ? null : jwt_decode(accessToken$.value);
});

const RESOURCE_HIERARCHY = {
  CHAT_BOT_MODULE: {
    BOT_MARKET_PLACE:{
      BOT:1
    },
    BOT: {
      '*': {
        // the '*' has a special meaning. * means there is a user defined resource is there
        ROOT_DIALOG_NODE: {
          '*': {
            CONDITION: 1,
            RESPONSE_NODE: 1,
          },
        },
        SUB_DIALOG_NODE: {
          '*': {
            CONDITION: 1,
            RESPONSE_NODE: 1,
          },
        },
        GROUP_DIALOG_NODE: {
          '*': { CONDITION: 1 },
        },
        INTENTS: {
          '*': { EXAMPLES: 1 },
        },
        ENTITY: {
          '*': { ENTITY_VALUE: 1 },
        },
        AGENT_BOT: 1,
        SETTINGS: 1,
        LOGS: 1,
        CHATBOT_SUMMARY: 1,
      },
  },
  },
  TRAINING_MODULE: { USER_UTTERANCES: 1 },
  ENGINE: { PUBLIC_BOT: 1 },
  BOT_MARKET_PLACE: 1,
  WORKFLOW_MODULE: {
  WORKFLOWS: {
    '*': 1
    },
    PUBLISHED_WORKFLOWS: 1,
    ON_PREM: 1
  },
  WELCOME_PAGE: 1,
  BILLING_PAGE: 1,
  CHAT_CHANNEL_MODULE: {
  CHANNEL: {
  '*': {
  INTEGRATION: {
  '*': 1
  }
  }
  }
  },
  WORKFLOW_MARKET_PLACE: 1,
  USERS_MODULE: { USERS: 1 },
}

const resourceHasStar = (resourceObj:TreeT<PermissionT>) => {
  return Object.keys(resourceObj).length === 1 && !!resourceObj["*"]
}

// const handleSingleStar = (parsedPath:{type:string,value:string}[], resourceObj:TreeT<PermissionT>, prevPath = []) => {
//   let keys = Object.keys(resourceObj)
//   return keys.reduce((paths, curr) => {
//     let currPath = [...prevPath, curr]
//     return [...paths, currPath, ...traverse(parsedPath.slice(1), resourceObj[curr], currPath)]
//   }, []as any)
// }


const pathSeqIden = (value:string) => ({ type: "iden", value, wildCard: false }) as {
  type: string;
  value: string;
  wildCard: boolean;
}

const parsePathSeg = (pathSeg:string) => {
  if (pathSeg.length === 1 && pathSeg === "*") { return { type: "single_star", wildCard: true } }
  else if (pathSeg.length === 2 && pathSeg === "**") { return { type: "dbl_star", wildCard: true } }
  return pathSeqIden(pathSeg)
}

const parsePath = (path:string) =>
  path.split("/").map(parsePathSeg)

const getResourceFromPathSeq = (resourceObj:any, { value }:any) => {
  if (resourceHasStar(resourceObj)) { return resourceObj["*"] }
  return R.prop(value, resourceObj)
}

// the path must be parsed and without wildcard in it
const getResourceObj = (path:PathT[], resourceObj:any) => {
  return path.reduce(getResourceFromPathSeq, resourceObj)
}

const matchPath = (path:PathT[], resourceObj:any) => {
  return !!getResourceObj(path, resourceObj)
}

const hasWildCard = R.any<PathT>(R.prop("wildCard"))

const hasDoubleStarAtEnd = R.compose<PathT[], PathT | undefined, boolean>(
  x=> x?.type === 'dbl_star',
  R.last,
)

const sepPathByWildCard = R.reduce((paths:PathT[], currPath:PathT) => {
  if (currPath.wildCard) {
    return [...paths, currPath] as PathT[]
  }
  const last = paths[paths.length - 1]
  if (Array.isArray(last)) {
    return [...paths.slice(0, paths.length - 1), [...last, currPath]] as PathT[]
  } else {
    return [...paths, [currPath]] as PathT[]
  }
}, [])

const combinePaths = (l1:any, l2:any) => {
  let paths = []
  for (let i = 0; i < l1.length; i++) {
    if (!l2[i].length) {
      paths.push(l1[i]);
      continue
    }
    for (let j = 0; j < l2[i].length; j++) {
      paths.push(R.append(l2[i][j], l1[i]))
    }
  }
  return paths
}


const traverseAllDecForSinglePath :any =  (path:any) => {
  let currResourceObj = getResourceObj(path.map(pathSeqIden), RESOURCE_HIERARCHY)
  if (!currResourceObj) { return [] }
  let keys = Object.keys(currResourceObj)
  return keys.reduce((possiblePaths:any, curr) => {
    let currPath = [...path, curr]
    return [...possiblePaths, currPath, ...traverseAllDecForSinglePath(currPath)]
  }, [])
}

const traverseAllDec = (paths:any, resource:any) => {
  return R.unnest(paths.map(traverseAllDecForSinglePath))
}

const handleDblStar :any = (path:any, resource:any) => {
  let doubleStar = path[path.length - 1]
  let otherPath = path.slice(0, path.length - 1)
  let generatedPaths = constructIndividualResources(otherPath.map(({ value }:any) => value).join("/"))
  return [...generatedPaths, ...traverseAllDec(generatedPaths, resource)]
}

const constructIndividualResources = (path:string) => {
  const parsedPath = parsePath(path) as PathT[]
  if (!hasWildCard(parsedPath) && matchPath(parsedPath, RESOURCE_HIERARCHY)) {
    return [parsedPath.map((path) => {if("value" in path) return path.value})]
  } else if (!hasDoubleStarAtEnd(parsedPath)) {
    let paths = sepPathByWildCard(parsedPath)
    return paths.reduce((possiblePaths: string[][], currPath:PathT) => {
      if (!possiblePaths.length && Array.isArray(currPath)) {
        return [currPath.map(({ value }) => value)]
      } else if (!possiblePaths.length && R.has("wildCard",currPath) && currPath.wildCard) {
        return [Object.keys(RESOURCE_HIERARCHY)]
      } else if (R.has("wildCard",currPath) && currPath.wildCard) {
        const currentPossiblePaths = possiblePaths.map(R.map(pathSeqIden)).map((path) => getResourceObj(path, RESOURCE_HIERARCHY)).map(Object.keys)
        return combinePaths(possiblePaths, currentPossiblePaths)
        // return possiblePaths.map((path, i) => R.unnest(R.xprod(path, currentPossiblePaths[i])))
      } else if(Array.isArray(currPath)) {
        return combinePaths(possiblePaths, [currPath.map(({value}) => value)])
      }
      return possiblePaths
    }, [])
  } else {
    return handleDblStar(parsedPath, RESOURCE_HIERARCHY)
  }
}
const appendChildrenPath = (paths:string[], currentPath:string) => [...paths, currentPath, "children"]

const addChildPaths = (resourcePaths:string[]) =>
  [
    ...resourcePaths.slice(0, resourcePaths.length - 1).reduce(appendChildrenPath, []),
    resourcePaths[resourcePaths.length - 1]
  ]


const accessObj = (str:string) => {
  const keys = R.split('.', str);
  const values = R.repeat(1, keys.length);

  return R.zipObj(keys, values);
}

const assignPermission = R.curry((access:string, permissionTree:{
  [key: string]: string;
}, resourcePath:string[]) => R.assocPath([...addChildPaths(resourcePath), "permission"], accessObj(access), permissionTree))

const addPermissionToTree = (tree:TreeT<PermissionT> |{}, [resourcePath, access]:[string,unknown]) => {
  const individualResourcesPath = constructIndividualResources(resourcePath) // [["CHAT_BOT_MODULE"], ["CHAT_BOT_MODULE", "BOT"]...]
  return individualResourcesPath.reduce(assignPermission(access as string), tree)
}

const generateSubTree = (acl:TreeT<PermissionT>, ws:string) => { // have to export
  const permissionList = acl[ws]
  const resourceTree = permissionList ? Object.entries(permissionList).reduce(addPermissionToTree, {}) : {}
  return { permission: {}, children: resourceTree } as TreeT<PermissionT>  // consider this root object as workspace
}

const getResourceFromTree = (resourcePath:string[], resourceTree:TreeT<PermissionT>): any => {
  if (!resourcePath.length) { return resourceTree }
  const currPath = resourcePath[0]
  const currResource = resourceTree.children
  if (resourceHasStar(currResource)) { return getResourceFromTree(resourcePath.slice(1), currResource["*"]) }
  return currResource[currPath] ? getResourceFromTree(resourcePath.slice(1), currResource[currPath]) : null
}

const checkPermission = R.curry((resourcePath:string, permission:"READ"|"WRITE"|"DELETE", resourceTree:TreeT<PermissionT>) => { // have to export
  const resource = getResourceFromTree(resourcePath.split("/"), resourceTree)
  if(!resource) {return false}
  const givenPermObj = accessObj(permission)
  const resourcePermissions = resource.permission
  return Object.keys(givenPermObj).every((perm) => resourcePermissions[perm] === 1)
})

const mockedLibraryFunction = (
  _workspace: string,
  _moduleName: string,
  _permission: "READ"|"WRITE"|"DELETE",
  _stoken: Record<string, any> | null
) => {
  // if (_stoken === null) {
  //   return false;
  // }

  // function getRandomInt(min: number, max: number) {
  //   min = Math.ceil(min);
  //   max = Math.floor(max);
  //   return Math.floor(Math.random() * (max - min) + min); // The maximum is exclusive and the minimum is inclusive
  // }
  // const rNum = getRandomInt(0, 3);

  // if (rNum <= 1) {
  //   return true;
  // }
  // if(MOCK_AUTH_PERMISSIONS){
  //   // const granted = (_moduleName.includes('BOT')&&_permission!=='DELETE') || _moduleName == "WORKFLOWS" ? true: false
  //   // const granted = _moduleName.includes('SUB_DIALOG_NODE')  ? false: true
  //       const granted = _permission!=='DELETE' ? true: false
  //   return granted;
  // }else{
    return getProductId() === 'AUTOMATE'? true : _stoken?checkPermission(_moduleName,_permission,generateSubTree(_stoken['acl'] as any, _workspace)):false
  // }
};

const initilizePermissionsSignal =
  (parsedAccess: typeof parsedToken$) =>
  (workspace: string, moduleName: string, permission: "READ"|"WRITE"|"DELETE") => {
    // console.log(
    //   `DOING :: 2 :: PERMISSION VALIDATION RETRIGGERD WITH ${JSON.stringify(
    //     parsedAccess
    //   )}`
    // );
    const permissionForModule$ = useComputed(() => {
      if (parsedToken$.value === null) {
        return null;
      }
      return mockedLibraryFunction(
        workspace,
        moduleName,
        permission,
        parsedToken$.value
      );
    });
    // console.log(
    //   `DOING :: 3 :: PERMISSION RETURNED ${permissionForModule$.value}`,moduleName
    // );
    return permissionForModule$;
  };

export const usePermissions = initilizePermissionsSignal(parsedToken$);

export const usePermissionSignal = (workspace: string, moduleName$: Signal<string>, permission: "READ"|"WRITE"|"DELETE") => {
  // console.log(
  //   `DOING :: 2 :: PERMISSION VALIDATION RETRIGGERD WITH ${JSON.stringify(
  //     parsedToken$
  //   )}`
  // );
  const permissionForModule$ = useComputed(() => {
    if (parsedToken$.value === null) {
      return null;
    }
    return mockedLibraryFunction(
      workspace,
      moduleName$.value,
      permission,
      parsedToken$.value
    );
  });
  // console.log(
  //   `DOING :: 3 :: PERMISSION RETURNED ${permissionForModule$.value}`,moduleName$.value
  // );
  return permissionForModule$;
};

export const PERMISSION_STATUS = {
  LOADING : 'loading',
  HAS_PERMISSION : 'has-permission',
  NO_PERMISSION : 'no-permission'
} as const

export const usePermissionSignalWithErrorHandling = (workspace: string, moduleName$: Signal<string | null>, permission: "READ"|"WRITE"|"DELETE") => {
  // console.log(
  //   `DOING :: 2 :: PERMISSION VALIDATION RETRIGGERD WITH ${JSON.stringify(
  //     parsedToken$
  //   )}`
  // );
  const permissionForModule$ = useComputed(() => {
    if (parsedToken$.value === null || moduleName$.value === null) {
      return PERMISSION_STATUS.LOADING;
    }
    const permissionDerived = mockedLibraryFunction(
      workspace,
      moduleName$.value,
      permission,
      parsedToken$.value
    );

    if(permissionDerived === true) {
      return PERMISSION_STATUS.HAS_PERMISSION
    } else {
      return PERMISSION_STATUS.NO_PERMISSION
    }
  });
  // console.log(
  //   `DOING :: 3 :: PERMISSION RETURNED ${permissionForModule$.value}`,moduleName$.value
  // );
  return permissionForModule$;
};




export const withAuth = executeWithAuthToken;

if (MOCK_AUTH_PERMISSIONS) {
  // setInterval(() => {
    // chatbot contributor
    // const generatedToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.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.l0G9LVe7mI2B-nsCiCXl_fA6tnTkKCZSzR9tan7ooko"
    //  admin
    const generatedToken = "eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpZCI6MzksImVtYWlsIjoibWFuanVsYS5tQHNraXR0ZXIuaW4iLCJ3c3MiOlt7ImlkIjoxNzUsIm5hbWUiOiJ2aW5vZGRldiIsIm93bmVySWQiOjM2LCJpc19tZmFfYWN0aXZlIjp0cnVlfSx7ImlkIjoxNzcsIm5hbWUiOiJtYW5qdWxhd29ya3NwYWNlIiwib3duZXJJZCI6MzksImlzX21mYV9hY3RpdmUiOmZhbHNlfV0sImFjbCI6eyJ2aW5vZGRldiI6eyJDSEFUX0JPVF9NT0RVTEUvKioiOiJSRUFELldSSVRFLkRFTEVURSIsIlRSQUlOSU5HX01PRFVMRS8qKiI6IlJFQUQuV1JJVEUuREVMRVRFIiwiQk9UX01BUktFVF9QTEFDRS8qKiI6IlJFQUQuV1JJVEUuREVMRVRFIiwiRU5HSU5FL1BVQkxJQ19CT1QiOiJSRUFELldSSVRFLkRFTEVURSIsIldPUktGTE9XX01PRFVMRS8qKiI6IlJFQUQuV1JJVEUuREVMRVRFIiwiV09SS0ZMT1dfTUFSS0VUX1BMQUNFLyoqIjoiUkVBRC5XUklURS5ERUxFVEUiLCJVU0VSU19NT0RVTEUvKioiOiJSRUFELldSSVRFLkRFTEVURSIsIldFTENPTUVfUEFHRSI6IlJFQUQiLCJCSUxMSU5HX1BBR0UiOiJSRUFELldSSVRFLkRFTEVURSIsIkNIQVRfQ0hBTk5FTF9NT0RVTEUvKioiOiJSRUFELldSSVRFLkRFTEVURSJ9LCJtYW5qdWxhd29ya3NwYWNlIjp7IkNIQVRfQk9UX01PRFVMRS8qKiI6IlJFQUQuV1JJVEUuREVMRVRFIiwiVFJBSU5JTkdfTU9EVUxFLyoqIjoiUkVBRC5XUklURS5ERUxFVEUiLCJCT1RfTUFSS0VUX1BMQUNFLyoqIjoiUkVBRC5XUklURS5ERUxFVEUiLCJFTkdJTkUvUFVCTElDX0JPVCI6IlJFQUQuV1JJVEUuREVMRVRFIiwiV09SS0ZMT1dfTU9EVUxFLyoqIjoiUkVBRC5XUklURS5ERUxFVEUiLCJXT1JLRkxPV19NQVJLRVRfUExBQ0UvKioiOiJSRUFELldSSVRFLkRFTEVURSIsIlVTRVJTX01PRFVMRS8qKiI6IlJFQUQuV1JJVEUuREVMRVRFIiwiV0VMQ09NRV9QQUdFIjoiUkVBRCIsIkJJTExJTkdfUEFHRSI6IlJFQUQuV1JJVEUuREVMRVRFIiwiQ0hBVF9DSEFOTkVMX01PRFVMRS8qKiI6IlJFQUQuV1JJVEUuREVMRVRFIn0sInNraXR0ZXIiOnsiQ0hBVF9CT1RfTU9EVUxFLyoqIjoiUkVBRC5XUklURS5ERUxFVEUiLCJUUkFJTklOR19NT0RVTEUvKioiOiJSRUFELldSSVRFLkRFTEVURSIsIkJPVF9NQVJLRVRfUExBQ0UvKioiOiJSRUFELldSSVRFLkRFTEVURSIsIkVOR0lORS9QVUJMSUNfQk9UIjoiUkVBRC5XUklURS5ERUxFVEUiLCJXT1JLRkxPV19NT0RVTEUvKioiOiJSRUFELldSSVRFLkRFTEVURSIsIldPUktGTE9XX01BUktFVF9QTEFDRS8qKiI6IlJFQUQuV1JJVEUuREVMRVRFIiwiVVNFUlNfTU9EVUxFLyoqIjoiUkVBRC5XUklURS5ERUxFVEUiLCJXRUxDT01FX1BBR0UiOiJSRUFEIiwiQklMTElOR19QQUdFIjoiUkVBRC5XUklURS5ERUxFVEUiLCJDSEFUX0NIQU5ORUxfTU9EVUxFLyoqIjoiUkVBRC5XUklURS5ERUxFVEUifX0sImlhdCI6MTY4NzM1NzM3NywiZXhwIjoxNjg3MzU4Mjc3fQ.VhofG4gvg4Qy-E5bsa6Z6aCv0jF0Ch4NNsp2xcmZ6mc"
    accessToken$.value = generatedToken;
  // }, 5000);
}

export const getParsedToken = () => {
  if (MOCK_AUTH_PERMISSIONS) {
    return {
      email: 'shri.ghayathri@skitter.in',
      exp: 1597149699,
      iat: 1597148799,
      id: 37,
      wss: [
        { id: 176, name: 'nirup', ownerId: 37, is_mfa_active: false },
        {
          id: 177,
          name: 'manjulaworkspace',
          ownerId: 39,
          is_mfa_active: false,
        },
        { id: 189, name: 'enterprise', ownerId: 32, is_mfa_active: false },
      ],
      mfa: true,
    } as const;
  }

  return parsedToken$.value;
};
// console.log(parsedToken$,parsedToken$.value,'tokenvalue')

export enum AuthType{
  NoToken,
  AuthNeeded,
  NoAuthNeeded
}
export const useMFAValidator =(workspace:string)=>{
  const decodedToken = getParsedToken();
    // console.log(decodedToken,'parsedtoken')
  const validator$ = useComputed(() => {
  if (decodedToken === null) {
      return AuthType.NoToken;
    }
  const workSpaceinList = decodedToken['wss'].filter(
    (a: any) => a.name === workspace
  );
  const mfaNeeded = workSpaceinList.length > 0 && workSpaceinList[0].is_mfa_active;
  const checkAuthenticated = (decodedToken: Record<string, any>) => {
    if (
      Object.keys(decodedToken).includes('mfa') &&
      decodedToken['mfa'] === true
    ) {
      return true;
    } else {
      return false;
    }
  };
  const mfaAuthenticated = checkAuthenticated(decodedToken);
  // console.log(mfaAuthenticated, mfaNeeded, 'workSpaceList');
  if (mfaNeeded === true) {
    if (mfaAuthenticated === false) {
      return AuthType.AuthNeeded;
    } else {
      return AuthType.NoAuthNeeded;
    }
  } else {
    return AuthType.NoAuthNeeded;
  }
})
return validator$
}

// if (MOCK_AUTH_PERMISSIONS) {
//   setInterval(() => {
//     const generatedToken = Math.random().toString();
//     accessToken$.value = generatedToken;
//     console.log(`DOING :: 1 :: ACCESS TOKEN VALUE CHANGED ${generatedToken}`);
//   }, 5000);
// }
